module.exports = __webpack_public_path__ + "img/vape-shop-custom-website-img-5.c80a7882.webp";